import script from "./AdminBiographyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminBiographyPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminBiographyPage.vue?vue&type=style&index=0&id=4d86f9f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d86f9f5"]])

export default __exports__